import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ScrollToTopOnRoute from "./ScrollToTopOnRoute";

import Home from "./pages/Home";

import AboutUs from "./pages/AboutUs";
import AwardRecognitions from "./pages/AwardRecognitions";

import BusinessForex from "./pages/Forex";
import BusinessPreciousMetals from "./pages/PreciousMetals";
import BusinessAssetManagement from "./pages/AssetManagement";

import PressCenter from "./pages/PressCenter";
import PC20171212001 from "./pages/PC20171212001";
import PC20161218001 from "./pages/PC20161218001";
import PC20161118001 from "./pages/PC20161118001";
import PC20160403001 from "./pages/PC20160403001";
/*import Announcement from './pages/Announcement';*/

import ContactUs from "./pages/ContactUs";

import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Career from "./pages/Career";

import PageNotFound from "./pages/PageNotFound";

/*
import Roster from './to-be-determined/Roster'
import Schedule from './to-be-determined/Schedule'
*/

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"

class Main extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props);
    //console.log('Main, constructor()');
  }

  render() {
    //console.log('Main, render()');
    //console.log(this);
    return MainJSX(this);
  }
}

const MainJSX = ctx => (
  <main>
    <Switch>
      {/*Home*/}
      <ScrollToTopOnRoute exact path="/" component={Home} pagepath="" />
      <ScrollToTopOnRoute
        exact
        path="/sc"
        isSetLang="true"
        lang="sc"
        component={Home}
        pagepath=""
      />
      <ScrollToTopOnRoute
        exact
        path="/en"
        isSetLang="true"
        lang="en"
        component={Home}
        pagepath=""
      />

      {/*About Us*/}
      <ScrollToTopOnRoute
        exact
        path="/about-us"
        component={AboutUs}
        pagepath="/about-us"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/about-us"
        isSetLang="true"
        lang="sc"
        component={AboutUs}
        pagepath="/about-us"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/about-us"
        isSetLang="true"
        lang="en"
        component={AboutUs}
        pagepath="/about-us"
      />

      <ScrollToTopOnRoute
        exact
        path="/awards-recognitions"
        component={AwardRecognitions}
        pagepath="/awards-recognitions"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/awards-recognitions"
        isSetLang="true"
        lang="sc"
        component={AwardRecognitions}
        pagepath="/awards-recognitions"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/awards-recognitions"
        isSetLang="true"
        lang="en"
        component={AwardRecognitions}
        pagepath="/awards-recognitions"
      />

      {/*Business*/}
      <ScrollToTopOnRoute
        exact
        path="/forex"
        component={BusinessForex}
        pagepath="/forex"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/forex"
        isSetLang="true"
        lang="sc"
        component={BusinessForex}
        pagepath="/forex"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/forex"
        isSetLang="true"
        lang="en"
        component={BusinessForex}
        pagepath="/forex"
      />

      {/*
				<ScrollToTopOnRoute exact path='/precious-metals' component={BusinessPreciousMetals} pagepath='/precious-metals' />
				<ScrollToTopOnRoute exact path='/sc/precious-metals' isSetLang='true' lang='sc' component={BusinessPreciousMetals} pagepath='/precious-metals' />
				<ScrollToTopOnRoute exact path='/en/precious-metals' isSetLang='true' lang='en' component={BusinessPreciousMetals} pagepath='/precious-metals' />
			*/}

      <ScrollToTopOnRoute
        exact
        path="/asset-management"
        component={BusinessAssetManagement}
        pagepath="/asset-management"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/asset-management"
        isSetLang="true"
        lang="sc"
        component={BusinessAssetManagement}
        pagepath="/asset-management"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/asset-management"
        isSetLang="true"
        lang="en"
        component={BusinessAssetManagement}
        pagepath="/asset-management"
      />

      {/*PressCenter*/}
      {/*
				<ScrollToTopOnRoute
					exact
					path="/press-center"
					component={PressCenter}
					pagepath="/press-center"
				/>
				<ScrollToTopOnRoute
					exact
					path="/sc/press-center"
					isSetLang="true"
					lang="sc"
					component={PressCenter}
					pagepath="/press-center"
				/>
				<ScrollToTopOnRoute
					exact
					path="/en/press-center"
					isSetLang="true"
					lang="en"
					component={PressCenter}
					pagepath="/press-center"
				/>
				*/}

      {/*PC-News*/}

      {/*
				<ScrollToTopOnRoute
					exact
					path="/pc-20171212001"
					component={PC20171212001}
					pagepath="/pc-20171212001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/sc/pc-20171212001"
					isSetLang="true"
					lang="sc"
					component={PC20171212001}
					pagepath="/pc-20171212001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/en/pc-20171212001"
					isSetLang="true"
					lang="en"
					component={PC20171212001}
					pagepath="/pc-20171212001"
				/>

				<ScrollToTopOnRoute
					exact
					path="/pc-20161218001"
					component={PC20161218001}
					pagepath="/pc-20161218001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/sc/pc-20161218001"
					isSetLang="true"
					lang="sc"
					component={PC20161218001}
					pagepath="/pc-20161218001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/en/pc-20161218001"
					isSetLang="true"
					lang="en"
					component={PC20161218001}
					pagepath="/pc-20161218001"
				/>

				<ScrollToTopOnRoute
					exact
					path="/pc-20161118001"
					component={PC20161118001}
					pagepath="/pc-20161118001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/sc/pc-20161118001"
					isSetLang="true"
					lang="sc"
					component={PC20161118001}
					pagepath="/pc-20161118001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/en/pc-20161118001"
					isSetLang="true"
					lang="en"
					component={PC20161118001}
					pagepath="/pc-20161118001"
				/>

				<ScrollToTopOnRoute
					exact
					path="/pc-20160403001"
					component={PC20160403001}
					pagepath="/pc-20160403001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/sc/pc-20160403001"
					isSetLang="true"
					lang="sc"
					component={PC20160403001}
					pagepath="/pc-20160403001"
				/>
				<ScrollToTopOnRoute
					exact
					path="/en/pc-20160403001"
					isSetLang="true"
					lang="en"
					component={PC20160403001}
					pagepath="/pc-20160403001"
				/>
				*/}

      {/*   <ScrollToTopOnRoute path='/announcement' component={Announcement}/>*/}

      {/*ContactUs*/}
      <ScrollToTopOnRoute
        exact
        path="/contact-us"
        component={ContactUs}
        pagepath="/contact-us"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/contact-us"
        isSetLang="true"
        lang="sc"
        component={ContactUs}
        pagepath="/contact-us"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/contact-us"
        isSetLang="true"
        lang="en"
        component={ContactUs}
        pagepath="/contact-us"
      />

      {/*Footer*/}
      <ScrollToTopOnRoute
        exact
        path="/career"
        component={Career}
        pagepath="/career"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/career"
        isSetLang="true"
        lang="sc"
        component={Career}
        pagepath="/career"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/career"
        isSetLang="true"
        lang="en"
        component={Career}
        pagepath="/career"
      />

      <ScrollToTopOnRoute
        exact
        path="/privacy-policy"
        component={PrivacyPolicy}
        pagepath="/privacy-policy"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/privacy-policy"
        isSetLang="true"
        lang="sc"
        component={PrivacyPolicy}
        pagepath="/privacy-policy"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/privacy-policy"
        isSetLang="true"
        lang="en"
        component={PrivacyPolicy}
        pagepath="/privacy-policy"
      />

      <ScrollToTopOnRoute
        exact
        path="/disclaimer"
        component={Disclaimer}
        pagepath="/disclaimer"
      />
      <ScrollToTopOnRoute
        exact
        path="/sc/disclaimer"
        isSetLang="true"
        lang="sc"
        component={Disclaimer}
        pagepath="/disclaimer"
      />
      <ScrollToTopOnRoute
        exact
        path="/en/disclaimer"
        isSetLang="true"
        lang="en"
        component={Disclaimer}
        pagepath="/disclaimer"
      />

      {/*Others --> 404*/}
      {/*}
        <ScrollToTopOnRoute component={PageNotFound}/>
      */}
      {/*Temporary to cope with google search result*/}
      <Route render={() => <Redirect to="/" />} />

      {/*}
      <Route path='/roster' component={Roster}/>
      <Route path='/schedule' component={Schedule}/>
      */}
    </Switch>
  </main>
);

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js